import { render } from "./OverlayPanel.vue?vue&type=template&id=590aa9e6"
import script from "./OverlayPanel.vue?vue&type=script&lang=js"
export * from "./OverlayPanel.vue?vue&type=script&lang=js"

import "./OverlayPanel.vue?vue&type=style&index=0&id=590aa9e6&lang=scss"
script.render = render

export default script